export default __webpack_public_path__ + "static/bodytrace-combo2.png?ea39bd119474";